<template>
  <div class="flex flex-col gap-[20px] h-full">
    <div class="flex flex-col gap-[15px] h-full">
      <div class="flex justify-between items-center pr-[15px]">
        <h1>基础信息</h1>

        <el-popover :show-arrow="false" placement="left-start" :width="140" trigger="click"
          popper-class="custom-dialog-popper px-0">
          <template #reference>
            <el-icon :size="25" class="cursor-pointer">
              <i-ep-operation />
            </el-icon>
          </template>
          <div class="w-full h-full">
            <div>
              <div class="flex gap-[6px] items-center">
                <label>temperature</label>
                <el-tooltip :enterable="false" popper-class="custom-dialog-tooltip" size="small" class="box-item"
                  effect="dark" content="采样温度在(0.3~0.7]区间。它控制采样随机性，高温使生成回答多样，低温使回答更确定，一般选0.6~0.7之间的值。
" placement="top-start">
                  <i-ep-questionFilled class="cursor-pointer" />
                </el-tooltip>
              </div>
              <div class="flex ml-[5px] gap-[4px] items-center">
                <el-slider v-model="taskStore.currentTaskDetail.advanced.temperature" :min="0.3" :step="0.01"
                  :max="0.7" />

                <span class="border rounded-[4px] px-[5px] text-center w-[50px]">{{
                  taskStore.currentTaskDetail.advanced.temperature
                  }}</span>
              </div>
            </div>
            <div>
              <div class="flex gap-[6px] items-center">
                <label>top_p</label>
                <el-tooltip :enterable="false" popper-class="custom-dialog-tooltip" size="small" class="box-item"
                  effect="dark" content="在生成文本时，从概率分布中选择累计概率达到某一阈值 P 的部分进行采样，一般选0.6~0.8之间的值。
" placement="top-start">
                  <i-ep-questionFilled class="cursor-pointer" />
                </el-tooltip>
              </div>
              <div class="flex gap-[4px] items-center">
                <el-slider v-model="taskStore.currentTaskDetail.advanced.top_p" :min="0" :step="0.1"
                  :max="1"></el-slider>

                <span class="border rounded-[4px] px-[5px] text-center w-[50px]">{{
                  taskStore.currentTaskDetail.advanced.top_p
                  }}</span>
              </div>
            </div>

            <div>
              <div class="flex gap-[6px] items-center cu">
                <label>frequency_penalty</label>
                <el-tooltip :enterable="false" popper-class="custom-dialog-tooltip" height="10px" size="small"
                  class="box-item" effect="dark" content="频率惩罚,如果为正,值越大,模型逐字重复同一行的概率越小" placement="top-start">
                  <i-ep-questionFilled class="cursor-pointer" />
                </el-tooltip>
              </div>
              <div class="flex gap-[4px] items-center">
                <el-slider :min="-2" :max="2" :step="0.1"
                  v-model="taskStore.currentTaskDetail.advanced.frequency_penalty" />

                <span class="border rounded-[4px] px-[5px] text-center w-[50px]">{{
                  taskStore.currentTaskDetail.advanced.frequency_penalty
                  }}</span>
              </div>
            </div>
          </div>
        </el-popover>
      </div>
      <el-form ref="ruleFormRef" :model="taskStore.currentTaskDetail" :rules="rules" label-position="top"
        label-width="auto" class="demo-ruleForm overflow-y-scroll flex-grow" :size="formSize" status-icon
        :disabled="formReadonly">
        <div class="flex h-full flex-col justify-between gap-[20px]">
          <div class="flex-grow overflow-y-auto pr-[15px] custom-scroll">
            <el-form-item label="模型选择" prop="industry">
              <el-select-v2 v-model="taskStore.currentTaskDetail.industry_id" placeholder="请选择模型"
                :options="industryOptions" :disabled="isDisabled" />
            </el-form-item>
            <el-form-item label="产品名称" prop="content.product_name">
              <el-input v-model="currentTaskContent.product_name" @blur="handleBlur" @focus="handleFocus"
                placeholder="请输入产品名称" :disabled="isDisabled" />
              <div v-show="isFocus"
                class="rounded-[5px] flex-wrap flex-row flex bg-white drop-shadow-xl w-[100%] p-[10px]">
                <span @mousedown.prevent="handleName(item)"
                  class="flex cursor-pointer rounded-[5px] hover:text-blue-600 mt-[10px] bg-slate-50 mr-[5px] p-[10px]"
                  :key="item" v-for="item in productNameHistory">{{ item }}</span>
              </div>
            </el-form-item>

            <el-form-item label="利益点" prop="content.benefits">
              <el-input :rows="10" v-model="currentTaskContent.benefits" placeholder="请输入产品利益点如“最高600万保额"
                type="textarea" />
            </el-form-item>
            <div v-if="isIndustryIn([2])" style="width: 100%" prop="scriptStructure">
              <div class="flex gap-[20px] justify-between">
                <div>脚本结构</div>
                <div><el-button type="primary" size="small" @click="generateRandomStructure">随机组合</el-button></div>
              </div>
            </div>

            <!-- 自定义模式下的标签选择 -->
            <div class="script-structure-form flex flex-col justify-between gap-[20px]">
              <!-- 1. 开头吸睛 -->
              <el-form-item v-if="isIndustryIn([2])" label="开头吸睛" prop="content.structure_begin">
                <el-select v-model="currentTaskContent.structure_begin" placeholder="请选择开头方式" multiple
                  :multiple-limit="1">
                  <el-option v-for="item in structureOptions.beginnings" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>

              <!-- 2. 激发兴趣 -->
              <el-form-item v-if="isIndustryIn([2])" label="激发兴趣" prop="content.structure_transition">
                <el-select v-model="currentTaskContent.structure_transition" placeholder="请选择过渡方式" multiple
                  :multiple-limit="2">
                  <el-option v-for="item in structureOptions.transitions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>

              <!-- 3. 产品优势 -->
              <el-form-item v-if="isIndustryIn([2])" label="产品优势" prop="content.structure_middle">
                <el-select v-model="currentTaskContent.structure_middle" placeholder="请选择产品优势展示方式" multiple>
                  <el-option v-for="item in structureOptions.advantages" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>

              <!-- 4. 行动号召 -->
              <el-form-item v-if="isIndustryIn([2])" label="行动号召" prop="content.structure_end">
                <el-select v-model="currentTaskContent.structure_end" placeholder="请选择结尾方式" multiple
                  :multiple-limit="2">
                  <el-option v-for="item in structureOptions.endings" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>

              <!-- 5. 口播类型 -->
              <el-form-item v-if="isIndustryIn([2])" label="口播类型" prop="number_of_character">
                <el-select v-model="currentTaskContent.number_of_character" placeholder="请选择口播类型">
                  <el-option label="单人口播" value="单人口播" />
                  <el-option label="多人口播" value="多人口播" />
                </el-select>
              </el-form-item>

              <!-- 6. 演员角色 -->
              <el-form-item v-if="isIndustryIn([2, 3])" label="演员角色" prop="character_profile">
                <el-input v-model="currentTaskContent.character_profile" placeholder="请输入演员角色描述" />
              </el-form-item>

              <!-- 7. 剧本场景 -->
              <el-form-item v-if="isIndustryIn([2])" label="剧本场景" prop="script_scene">
                <el-input v-model="currentTaskContent.script_scene" placeholder="请输入剧本场景描述" />
              </el-form-item>
            </div>
            <!-- </div> -->
            <!-- <el-form-item label="可变利益点" prop="content.benefits_unfixed">
              <el-input
                :rows="10"
                v-model="currentTaskContent.benefits_unfixed"
                placeholder="请输入产品利益点如“最高600万保额"
                type="textarea"
              />
            </el-form-item> -->

            <el-form-item v-if="isIndustryIn([1])" label="角色设定" prop="content.target_audience">
              <el-input type="textarea" :rows="3" :maxLength="20" v-model="currentTaskContent.target_audience"
                placeholder="请输入角色设定,如“老年人”、“上班族”,用逗号隔开。" />
            </el-form-item>

            <el-form-item v-if="isIndustryIn([1])" label="剧本场景" prop="content.script_scene">
              <el-input type="textarea" :rows="3" :maxLength="50" v-model="currentTaskContent.script_scene"
                placeholder="选填,如公司会议室。" />
            </el-form-item>

            <!-- 剧本类型 -->
            <el-form-item v-if="isIndustryIn([1])" label="剧本类型" prop="content.script_style">
              <el-select-v2 v-model="currentTaskContent.script_style" placeholder="请选择样式" :options="options" />
            </el-form-item>

            <!-- 模式选择 -->
            <el-form-item v-if="isIndustryIn([1])" label="模式选择" prop="content.script_mode">
              <div class="text-[11px] text-[#919192] flex items-center gap-[4px]">
                <el-icon><i-ep-questionFilled /></el-icon>
                {{ modeTips }}
              </div>
              <el-radio-group v-model="currentTaskContent.script_mode" @change="fetchKeywords">
                <el-radio value="常规模式">常规模式</el-radio>
                <el-radio value="随机模式">随机模式</el-radio>
                <el-radio value="热点模式">热点模式</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="keyword">
              <el-skeleton class="w-full h-full" :loading="keyWordLoading" animated v-if="keyWordLoading">
                <template #template>
                  <el-skeleton :rows="2" />
                </template>
              </el-skeleton>
              <div v-else>
                <div class="flex flex-wrap gap-[6px]" v-if="currentTaskContent.script_mode === '热点模式'">
                  <div @click="saveHotTopic(wordItem)" :class="[
                    'text-[14px] key-word-item cursor-pointer bg-[#f3f3f3] text-[#1c1c1c] duration-200 rounded-[4px] px-[8px] py-[2px]',
                    {
                      highlight: currentTaskContent.keywords?.toString() === wordItem.keyword,
                      disabled: formReadonly
                    }
                  ]" v-for="(wordItem, index) in taskStore.keyWordMap[
                    taskStore.currentTaskDetail.id
                  ]?.[currentTaskContent.script_mode]" :title="taskStore.describeKeyword(wordItem)" :key="index">
                    <div>
                      {{ wordItem.keyword }}
                    </div>
                  </div>
                </div>

                <div class="flex flex-wrap gap-[6px]" v-else>
                  <div @click="saveRandomWord(word)" :class="[
                    'text-[14px] key-word-item cursor-pointer bg-[#f3f3f3] text-[#1c1c1c] duration-200 rounded-[4px] px-[8px] py-[2px]',
                    {
                      highlight: currentTaskContent.keywords?.toString() === word.toString(),
                      disabled: formReadonly
                    }
                  ]" v-for="(word, index) in taskStore.keyWordMap[taskStore.currentTaskDetail.id]?.[
                    currentTaskContent.script_mode
                  ]" :key="index">
                    <div>
                      <div v-for="(item, index) in word" :key="index">
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-button type="primary" size="small" color="#6a50fd" :loading="keyWordLoading" v-if="
              taskStore.keyWordMap[taskStore.currentTaskDetail.id]?.[
                taskStore.currentTaskDetail.content.script_mode
              ]?.length ?? false
            " @click="fetchKeywords">刷新</el-button>
          </div>

          <el-form-item class="mb-[0px]">
            <div class="flex w-full justify-end pr-[20px]">
              <el-button @click="resetForm(ruleFormRef)">清空输入</el-button>
              <el-button type="primary" @click="submitForm(ruleFormRef)" color="#6a50fd">
                开始生成
              </el-button>

              <!-- <el-popconfirm title="确定重新生成? 已生成灵感及剧本被覆盖" width="250px" confirmButtonText="确认" cancelButtonText="取消"
                @confirm="reSubmitForm(ruleFormRef)">
                <template #reference>
                  <el-button type="primary" color="#6a50fd"> 开始生成 </el-button>
                </template>
              </el-popconfirm> -->
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { useTaskStore } from '@/store/taskStore'
import { useLayoutStore } from '../../store/layoutStore'
import { useFormStore } from '../../store/formStore'
import { eventTrackingFunc } from '../../utils/utils'
import { useLLMStore } from '../../store/llm'
import { updateTask, getTaskDetail } from '@/service/task'
import { ref, reactive, computed, watch, toRefs, nextTick } from 'vue'
import { modeEnum } from '../../utils/enums'
import { ElMessage } from 'element-plus'

const taskStore = useTaskStore()
const layoutStore = useLayoutStore()
const llmStore = useLLMStore()
const formStore = useFormStore()

const formSize = ref('default')
const ruleFormRef = ref()
const formReadonly = ref(false)

const keyWordLoading = ref(false)
const isFocus = ref(false)
const industryOptions = [
  { value: 1, label: '金融-通用' },
  { value: 2, label: '金融-口播' },
  { value: 3, label: '通用' }
]

// 脚本结构选项
const structureOptions = {
  beginnings: [
    { label: '圈定人群', value: '圈定人群' },
    { label: '热梗引入', value: '热梗引入' },
    { label: '产品优势', value: '产品优势' },
    { label: '背书优势', value: '背书优势' },
    { label: '直击痛点', value: '直击痛点' },
    { label: '正话反说', value: '正话反说' },
    { label: '劝诫式开头', value: '劝诫式开头' },
    { label: '提问式开头', value: '提问式开头' },
    { label: '真实案例', value: '真实案例' },
    { label: '利益点对比', value: '利益点对比' }
  ],
  transitions: [
    { label: '放大痛点', value: '放大痛点' },
    { label: '借款场景', value: '借款场景' },
    { label: '使用感受', value: '使用感受' },
    { label: '突出优惠活动', value: '突出优惠活动' }
  ],
  advantages: [
    { label: '额度利益点营销', value: '额度利益点营销' },
    { label: '分期利益点营销', value: '分期利益点营销' },
    { label: '利息利益点营销', value: '利息利益点营销' },
    { label: '申请流程简单', value: '申请流程简单' },
    { label: '到账速度快', value: '到账速度快' },
    { label: '品牌背书', value: '品牌背书' },
    { label: '使用收益', value: '使用收益' },
    { label: '申请流程演示', value: '申请流程演示' },
    { label: '额度展示', value: '额度展示' },
    { label: '优惠活动', value: '优惠活动' }
  ],
  endings: [
    { label: '引导下载', value: '引导下载' },
    { label: '申请额度', value: '申请额度' }
  ]
}

// 脚本模式


const isIndustryIn = computed(() => (industryIds) => {
  return industryIds.includes(taskStore.currentTaskDetail.industry_id)
})

// 生成随机结构
const generateRandomStructure = () => {
  // 随机选择开头（固定选择一个）
  const randomBeginning =
    structureOptions.beginnings[Math.floor(Math.random() * structureOptions.beginnings.length)]
  currentTaskContent.value.structure_begin = [randomBeginning.value]

  // 随机选择过渡（1-2个）
  const transitionCount = Math.floor(Math.random() * 2) + 1
  const shuffledTransitions = [...structureOptions.transitions].sort(() => 0.5 - Math.random())
  currentTaskContent.value.structure_transition = shuffledTransitions
    .slice(0, transitionCount)
    .map((item) => item.value)

  // 随机选择产品优势（2-4个）
  const advantageCount = Math.floor(Math.random() * 3) + 2
  const shuffledAdvantages = [...structureOptions.advantages].sort(() => 0.5 - Math.random())
  currentTaskContent.value.structure_middle = shuffledAdvantages
    .slice(0, advantageCount)
    .map((item) => item.value)

  // 随机选择结尾（1-2个）
  const endingCount = Math.floor(Math.random() * 2) + 1
  const shuffledEndings = [...structureOptions.endings].sort(() => 0.5 - Math.random())
  currentTaskContent.value.structure_end = shuffledEndings
    .slice(0, endingCount)
    .map((item) => item.value)
}

const currentTaskId = computed(() => taskStore.currentTaskDetail.id)
const allTotal = computed(() => taskStore.allTotal)
const currentStatus = computed(() => taskStore.rawTasks[currentTaskId.value]?.status ?? '草稿')
const results = computed(() => {
  const newObj = {}
  if (llmStore.results[currentTaskId.value]) {
    Object.keys(llmStore.results[currentTaskId.value]).forEach((key) => {
      if (key.startsWith('insp_')) {
        newObj[key] = llmStore.results[currentTaskId.value][key]
      }
    })
  }
  return newObj
})
const productNameHistory = computed(() =>
  formStore.getProductName() ? Object.keys(formStore.getProductName()) : ''
)
const isDisabled = computed(() => {
  return currentStatus.value !== '草稿'
})
const currentTaskStatus = computed(() => taskStore.rawTasks[currentTaskId.value].status)
// const currentTaskContent = computed(() => {
//   let obj = {
//     structure_begin: [],
//     structure_transition: [],
//     structure_middle: [],
//     structure_end: [],
//     number_of_character: '单人口播',
//     character_profile: '',
//     script_scene: ''
//   }
//   return Object.assign(taskStore.currentTaskDetail.content, obj)
// })
const currentTaskContent = computed(() => taskStore.currentTaskDetail.content)

const options = [
  { value: '口播', label: '口播' },
  { value: '剧情', label: '剧情' }
]

const handleFocus = () => {
  isFocus.value = true
}

const handleBlur = () => {
  isFocus.value = false
}

const fetchKeywords = async (value) => {
  keyWordLoading.value = true
  await taskStore.fetchKeywords(value)
  keyWordLoading.value = false
}

const showRegenerateButton = computed(() => {
  return currentTaskStatus.value !== '草稿'
})
const modeTips = computed(() => {
  return {
    常规模式: '按照填写信息让智能编导帮您生成剧本',
    随机模式: '在下列随机词中选中一组随机词组,结合填写信息帮您生成剧本',
    热点模式: '在下列热点词中选中一个热点词,结合填写信息帮您生成剧本'
  }[currentTaskContent.value.script_mode]
})

const rules = reactive({
  content: {
    product_name: [
      { required: true, message: '请输入产品名称', trigger: 'blur' },
      { min: 1, max: 20, message: 'Length should be 1 to 20', trigger: 'blur' }
    ],
    benefits: [
      { required: true, message: '请输入利益点', trigger: 'blur' },
      { min: 1, max: 300, message: 'Length should be 1 to 300', trigger: 'blur' }
    ],
    target_audience: [
      { message: '请输入角色设定', trigger: 'blur' },
      { min: 1, max: 20, message: 'Length should be 1 to 20', trigger: 'blur' }
    ],
    script_scene: [
      { required: false, message: '剧本场景', trigger: 'blur' },
      { min: 1, max: 50, message: 'Length should be 1 to 50', trigger: 'blur' }
    ],
    script_mode: [{ required: true, message: '请选择模式', trigger: 'change' }],
    keywords: [
      {
        type: 'array',
        trigger: 'change',
        required: true,
        validator: (rule, value, callback) => {
          if (currentTaskContent.value.script_mode === '常规模式') {
            callback()
          } else {
            if (value.length) {
              callback()
            } else {
              callback(new Error('请选择关键词'))
            }
          }
        }
      }
    ],
    structure_begin: [{ required: true, message: '请选择开头方式', trigger: 'change' }],
    structure_transition: [
      {
        type: 'array',
        required: true,
        message: '请选择至少一个过渡方式',
        trigger: 'change'
      }
    ],
    structure_middle: [
      {
        type: 'array',
        required: true,
        message: '请选择至少一个产品优势',
        trigger: 'change'
      }
    ],
    structure_end: [
      {
        type: 'array',
        required: true,
        message: '请选择至少一个结尾方式',
        trigger: 'change'
      }
    ]
  }
})

const saveRandomWord = (word) => {
  if (formReadonly.value) return
  taskStore.currentTaskDetail.content.keywords = word
}

const saveHotTopic = (wordItem) => {
  if (formReadonly.value) return
  taskStore.currentTaskDetail.content.keywords = [wordItem.keyword]
}

const handleName = (item) => {
  currentTaskContent.value.product_name = item
  const historyObj = formStore.getProductName()
  currentTaskContent.value.benefits = historyObj[item].benefits
  isFocus.value = false
}

const maxKey = computed(() => {
  let keys = []
  if (Object.keys(results.value).length > 0) {
    keys = Object.keys(results?.value).map((key) => {
      return key.split('_')[1]
    })
  }
  let newKeys = []
  for (let i = keys.length + 1; i <= allTotal.value + 3; i++) {
    newKeys.push(i)
  }
  const array = newKeys.map((item) => {
    return `insp_${item}`
  })
  taskStore.$patch((state) => {
    state.allTotal = allTotal.value + 3
  })
  return array
})

const submitForm = async (formEl) => {
  const currentTaskId = taskStore.currentTaskDetail.id
  if (!formEl) return
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      try {
        const industry_id = taskStore.currentTaskDetail.industry_id

        let fullName = ''
        if (industry_id == 1) {
          fullName = `${currentTaskContent.value.product_name}-${currentTaskContent.value.script_mode}`
        } else if (industry_id == 2) {
          fullName = `${currentTaskContent.value.product_name}-口播`
        } else if (industry_id == 3) {
          fullName = `${currentTaskContent.value.product_name}-${currentTaskContent.value.character_profile}`
        }

        const oldName = taskStore.rawTasks[currentTaskId].name

        const currentUseName = oldName !== '新任务' ? oldName : fullName

        layoutStore.showResults = true // 保存成功才显示结果页面
        // if (!taskStore.currentTaskDetail.content.benefits_unfixed) {
        //   taskStore.currentTaskDetail.content.benefits_unfixed = ''
        // }
        const { code } = await updateTask(currentTaskId, {
          ...taskStore.currentTaskDetail,
          name: currentUseName
        })

        if (code === 0) {
          taskStore.rawTasks[currentTaskId].name = currentUseName
          layoutStore.showResults = true // 保存成功才显示结果页面
          await taskStore.generateTask({
            variables: taskStore.variables,
            industry_id: taskStore.currentTaskDetail.industry_id,
            keys: maxKey.value,
            llm_type: modeEnum[currentTaskContent.value.script_mode],
            task_id: currentTaskId,
            advanced: currentTaskContent.value.advanced
          })

          // 生成任务完成后,获取最新的任务详情
          const { code: detailCode, data: taskDetail } = await getTaskDetail(currentTaskId)
          if (detailCode === 0) {
            taskStore.updateTaskDetail(taskDetail)
          } else {
            ElMessage.error('获取任务详情失败')
          }
        }
        formStore.addProductName(taskStore.currentTaskDetail.content)
        // 埋点
        const eventTrackingParmas = {
          customized_id: currentTaskId + '',
          event_name: 'TaskGenerate',
          event_type: 'Click',
          event_time: 0,
          page_name: ''
        }
        eventTrackingFunc(eventTrackingParmas)
      } catch (error) {
        console.log(error)
        ElMessage.error('生成任务失败')
      }
    } else {
      console.log('error submit!', fields)
      ElMessage.error('请完善必填项')
    }
  })
}

const resetForm = (formEl) => {
  if (!formEl) return
  taskStore.resetFields()
}

watch(
  () => currentStatus.value,
  (taskStatus) => {
    if (taskStatus === '生成中') {
      // 生成中状态下只读
      formReadonly.value = true
    } else {
      formReadonly.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="scss" scoped>
.box-item {
  width: 500px;
}

.highlight {
  background: #6a50fd;
  color: #fff;
  box-shadow: 0 0 5px 1px rgba(106, 80, 253, 0.1);
}

// :deep(.el-select__wrapper) {
//   height: 40px !important;
// }

// :deep(.el-input__inner) {
//   height: 40px !important;
// }

:deep(.el-radio__input.is-checked + .el-radio__label) {
  color: #6a50fd;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  border-color: #6a50fd;
  background: #6a50fd;
}

:deep(.el-button:not(.is-disabled):hover) {
  background: #6a50fd;
  color: #fff;
  border-color: #6a50fd;
}

.custom-scroll {
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f5f4ff;
    border-radius: 3px;
  }
}
</style>

<style lang="scss" scoped>
.custom-dialog-popper {
  width: 300px !important;
  height: auto;
  padding: 15px !important;
  box-sizing: border-box;
}

.custom-dialog-tooltip {
  width: 450px !important;
  padding: 15px !important;
  box-sizing: border-box;
}

.el-slider__button-wrapper {
  width: 15px !important;
  height: 15px !important;
  top: -7.5px !important;
}

.key-word-item:not(.disabled) {
  &:hover {
    background: #6a50fd;
    color: #fff;
    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.1);
  }
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}
</style>
